export default __webpack_public_path__ + "static/media/coin.7e12761e.obj";